import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ValidateClaimGlComponent } from '../../validate-claim-gl/validate-claim-gl/validate-claim-gl.component';

@Component({
  selector: 'app-additional-document-submission-gl',
  templateUrl: './additional-document-submission-gl.component.html',
  styleUrls: ['./additional-document-submission-gl.component.scss']
})
export class AdditionalDocumentSubmissionGlComponent implements OnInit {

  isParentTabSelectionChange:boolean=false;
  dataReqiredForDocumentUpload: any
  selectedTab = 0;
  claimEntryId: number;
  resetDocuments: boolean;
  @Input() set resetAdditionalDocSubmissionTab(value){
    if (value) {
      this.setActiveTab(0);
      this.isParentTabSelectionChange=true;
      this.resetAdditionalDocSubmissionTabValue.emit();
    }
  }

  @ViewChild(ValidateClaimGlComponent, { static: true })
  validateClaimGlComponent: ValidateClaimGlComponent;

  @Output() resetAdditionalDocSubmissionTabValue = new EventEmitter<any>();
  tabs = [
    {
      name: "Validate existing claim",
      disabled: false
    },
    {
      name: "Document Upload",
      disabled: true
    }
  ];

  constructor() { }

  ngOnInit() {
    this.setActiveTab(0);
  }

  setActiveTab(tabIndex: number) {
    this.selectedTab = tabIndex;
    for (let i = 0; i < this.tabs.length; i++) {
      if (tabIndex == i) {
        this.tabs[i].disabled = false;
      } else {
        this.tabs[i].disabled = true;
      }
    }
  }

  validInput(data: any) {
    if (data && data.claimEntryId) {
      this.claimEntryId = data.claimEntryId;
      this.setActiveTab(1);
      this.dataReqiredForDocumentUpload = data;
    }
  }

  documentUploaded(data: any) {
    if (data && data.isDocumentUploaded) {
      this.setActiveTab(0);
      this.validateClaimGlComponent.resetFromSettings();
    }
  }

  parentChange(data: any) {
    this.resetDocuments = data;
  }

  resetIsParentTabSelectionChangeValue(){
    this.isParentTabSelectionChange=false;
  }

  enableOnlineGenerateInputTab() {
    this.setActiveTab(0);
  }

}
